module.exports = __webpack_public_path__ + "static/media/light-switch-on.13a5909b.svg";